module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-welcome"
  }, [_c('page-header', {
    attrs: {
      "title": _vm.title,
      "subTitle": _vm.subtitle
    }
  }), _c('div', {
    staticClass: "content"
  }, [_c('product-list', {
    attrs: {
      "products": _vm.products
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-03b0687b","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Welcome/Welcome.vue
// module id = 585
// module chunks = 1